<template>
    <v-toolbar height="70" class="" app fixed>
    	<v-toolbar-side-icon @click="clickHandler"
			class="grey--text text--darken-2"/>
		</v-toolbar-side-icon>
		<v-layout class="pt-2">
			<v-flex xs3>
				<v-autocomplete
					ref="autocomplete"
					v-model="selectedBuilding"
					v-on:click="selectedBuilding = null"
					@keyup.enter="directEnter"
					hide-no-data
					auto-select-first
					autocomplete
					solo
					:loading="buildingItems.length==0"
					flat
					style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
					:items="buildingItems"
					:filter="customFilter"
					label="Building Name / Number / Addr"
					single-line
					>
					<template
				        slot="selection"
				        slot-scope="{ item, tile }"
				      >
				      	<v-layout v-if="selectedBuilding" v-on:click="selectedBuilding = null">
				        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
				        	{{item.bldgAlpha}}
				        </v-list-tile-avatar>
				        <v-list-tile-content>
				          <v-list-tile-title>
				          	{{item.name}}
				          </v-list-tile-title>
				          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
				        </v-list-tile-content>
				    	</v-layout>
				      </template>
					<template
				        slot="item"
				        slot-scope="{ item, tile }"
				      >
				        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
				        	{{item.bldgAlpha}}
				        </v-list-tile-avatar>
				        <v-list-tile-content>
				          <v-list-tile-title>
				          	{{item.name}}
				          </v-list-tile-title>
				          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
				        </v-list-tile-content>
				      </template>
				</v-autocomplete>
		  	</v-flex>
		  	<!-- v-if="this.$store.state.space.selectedBuilding" -->
		  	<v-flex class="pl-3" :class="xxl ? 'xs1' : 'xs2'"> 
				<v-autocomplete
					ref="roomselect"					
					v-model="selectedRoom"
					autocomplete
					auto-select-first					
					solo
					flat
					:items="roomItems"
					label="Room"
					single-line
				></v-autocomplete>
		  	</v-flex>
		  	<v-flex xs1 class="ml-3">
		  		<v-autocomplete 
		  			:items="elevatorItems"
		  			flat
		  			solo
		  			label="Floor"
		  			v-model="currentFloor"
		  			>
		  		</v-autocomplete>
		  	</v-flex>
		  	<v-flex class = "ml-3">
			  	<v-toolbar-title class="topTitle">	
			  			<v-layout align-center row fill-height>			
						<img src="../images/ua_block_rgb_3.png" class="blocka">
						<a href="/" 
							style="text-decoration: none;" 
							:style="darkTheme ? 'color: whitesmoke;' : 'color: #000000c7;'"> 
								Interactive Floorplans 
						</a>
					 	</v-layout>
				</v-toolbar-title>	
			</v-flex>
			<!-- <v-flex v-if="isSuperUser"> -->

			</v-layout>
			<v-flex xs2 v-if="useBetaGIS" >
				<v-chip close class="headline pa-2 elevation-2" color="lime accent-2" @input="stopUsingBetaGIS">
					{{useBetaGIS ? 'Using Beta GIS' : ''}}
				</v-chip>
			</v-flex>
				<v-layout column align-center>
				<v-flex v-if="!impersonate">{{this.userProfile.netid}}</v-flex>
				<v-flex v-else><v-btn dark small class="px-2" color="red darken-3">
					<v-layout row justify-space-between>{{isSuperUser ? impersonate && impersonate.netid : ''}}
						<v-icon small @click="setImpersonate(null)">close</v-icon>
					</v-layout>
				</v-btn></v-flex>
				</v-layout>
				<v-icon v-if="viewRestricted" medium color="red darken-3" class="pl-2">verified_user</v-icon>
				<DBToggleBtn/>
			</v-flex>
			<v-tooltip left>
				<v-btn slot="activator" icon @click="updateOptionsSidebar(true)">
                    <v-icon>settings</v-icon>
                </v-btn>
				<span>Settings</span>
			</v-tooltip>
			<template v-if="isSuperUser">
			<v-badge overlap color="red" :value="showIndicatorPhotoReview">
			    <template v-slot:badge>
			    	<span class="caption">{{showIndicatorPhotoReview}}</span>
			    </template>
				<v-tooltip left>
					<v-btn slot="activator" icon @click="updateAdminSidebar(!adminSidebarOpen)">
	                    <v-icon class="grey--text text--darken-2">menu</v-icon>
	                </v-btn>
					<span>Admin Menu</span>
				</v-tooltip>
			</v-badge>
			</template>
		</v-layout>

	</v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import { mapMutations, mapActions } from 'vuex'
import Vuex from 'vuex'
import router from '../router'
import TestButton from './TestButton'
import DBToggleBtn from './DBToggleBtn'
import jscookie from 'js-cookie'

export default {  
  name: 'TopBanner',

  data () {
	return {
	  bldgAutoSelect: null
	}
  },

  components : { TestButton, DBToggleBtn },

  computed: {
  	...mapState({   adminSidebarOpen : state => state.ui.adminSidebarOpen, 
  					isSuperUser: state => state.user.isSuperUser,
  					darkTheme: state => state.ui.darkTheme,
  					showIndicatorPhotoReview: state => state.ui.showIndicatorPhotoReview,
  					useDevDatabase: state => state.ui.useDevDatabase,
  					userProfile: state => state.user.userProfile,
  					useBetaGIS: state => state.restServices.useBetaGIS,
  					impersonate: state => state.user.impersonate,
					viewRestricted: state => state.user.viewRestricted
  				}),

	buildingItems : function () {
	  const items = []
	  this.$store.state.space.buildings.forEach(bldg => {
		bldg.text = `${bldg.bldgAlpha} - ${bldg.name}`
		bldg.value = bldg.bldgAlpha
		// Load only 'Active' status buildings
		if (bldg.status == 'A') { items.push(bldg) }
	  })
	  return items
	},

/*	useBetaGIS: function () {
		if (jscookie.get('if_use_beta_gis') == 'true') {      
      		return true
    	}		
	},*/

	roomItems : function () {
	  return this.$store.state.space.buildingRooms.map((room) => {return room.number})
	},

	xxl: function() {
		let width = window.innerWidth
		console.log("width", width)
		if (width > 1920) { return true }
	},

	elevatorItems: function () {
		return [ 	{ text : 'Floor B', value: 'B' },
					{ text : 'Floor 1', value: '1' },
					{ text : 'Floor 2', value: '2' },
					{ text : 'Floor 3', value: '3' },
					{ text : 'Floor 4', value: '4' },
					{ text : 'Floor 5', value: '5' },
					{ text : 'Floor 6', value: '6' },
					{ text : 'Floor 7', value: '7' },
					{ text : 'Floor 8', value: '8' },
					{ text : 'Floor 9', value: '9' },
					{ text : 'Floor 10', value: '10' },
					{ text : 'Floor 11', value: '11' },
					{ text : 'Floor 12', value: '12' },
					{ text : 'Floor 1M', value: '1M' },
					{ text : 'Floor 2M', value: '2M' },
					{ text : 'Floor 3M', value: '3M' },
					{ text : 'Floor 4M', value: '4M' },
				]
	},

	selectedBuilding : {
	    get () {
	    	return this.$store.state.space.selectedBuilding ? this.$store.state.space.selectedBuilding.bldgAlpha : null
	    },

	    set (value) {	
	    	//this.$refs.roomselect.focus()	    	
	    	this.updateSelectionCentering(true)
	    	this.selectBuilding(value).then(() => {
	    		// Taken out 8/5/19 as part of making main searches such as "5000-1" work to go straight to drawing for non-georeferenced building.
	    		// There seemed to be no effect anywhere in the system except that Building switch will not always put currentfloor to 1
/*	    		if (value) {
	    			//this.setCurrentFloor("1")  // Always go to Floor 1 on a switch of Building
					// Select floor 1 if it exists, else select first valid floor
					this.setCurrentFloor((this.$store.state.space.selectedBuilding.floors.indexOf(this.$store.state.ui.currentFloor) === -1) ? this.$store.state.space.selectedBuilding.floors[0] : "1")
				}*/
	    	})
	    	
	    }
	},

	currentFloor : {
		get() { return this.$store.state.ui.currentFloor },
		set (value) {
			this.setCurrentFloor(value)
		}
	},

    selectedRoom : {
	    get () {
	    	return this.$store.state.space.selectedRoom ? this.$store.state.space.selectedRoom.number : null
	    },
	    set (value) {
	    	this.updateSelectionCentering(true)
	        this.fetchFullRoom({bldgAlpha: this.selectedBuilding, number: value})
	        
	        if (this.$router.history.current.name === 'roomtableBldg') {
			this.$router.push({ name: 'roomtableBldg', params: { bldg: value }})
		}
	    }
	},

  },

  watch: {
		isSuperUser (val) { if (val) { 
			this.isSuperUser && this.fetchUnapprovedPhotos().then((data) => {
		  		this.setShowIndicatorPhotoReview(data.length)
		  	}) 
		}},
	},

/*  created: function () {
  	this.isSuperUser && this.fetchUnapprovedPhotos().then((data) => {
  		this.setShowIndicatorPhotoReview(data.length)
  	})
  	
  },*/

  methods: {
	...mapMutations([	'updateMainSidebar',
						'updateSelectionCentering',
						'setSelectedRoom', 
						'setSelectedBuilding',
						'setCurrentFloor',
						'updateContentSidebar',
						'updateSearchResultSidebar',
						'updateAdminSidebar',
						'updateOptionsSidebar',
						'setShowIndicatorPhotoReview',
						'setUseDevDatabase',
						'setBuildingCardOpen',
						'updateRoomAssociationSidebar',
						'setImpersonate',
	]),
	...mapActions([		'selectBuilding', 'fetchFullRoom', 'fetchUnapprovedPhotos', 'addNullFeatures', 'initializeData']),

	stopUsingBetaGIS: function() {
		console.log("stopped")
		//this.showGISChip = false
		jscookie.set('if_use_beta_gis', false)
		this.$router.go()	
	},

	directEnter(e) {
		let payload = e.target.value.includes('-') && e.target.value.split("-")[0]
		if (payload && this.isSuperUser) {
			//this.selectedBuilding = payload.replace(/^0+/, '')
			this.gotoDrawing(e.target.value)	
		}
		
		this.$refs.autocomplete.isMenuActive = false
	},

	toggleDB: function () {
		this.setUseDevDatabase(!this.$store.state.ui.useDevDatabase)
        this.initializeData('refresh')
	},

	gotoDrawing: function(dwgName) {
		let drawingName = dwgName.split(".")[0]+".dwg"
		console.log("Go To Drawing", drawingName)
		this.addNullFeatures({ 'floor': this.currentFloor, 'docName': drawingName })
		this.setBuildingCardOpen(false)
		this.updateRoomAssociationSidebar(true)
	},

	customFilter (item, queryText, itemText) {
		//return JSON.stringify(item).toLowerCase().indexOf(queryText.toLowerCase()) > -1 
		
        const bldgAlpha = item.bldgAlpha.toLowerCase()
        const searchBlob = 	item.bldgAlpha + item.name + item.address + item.city + item.state + item.abbrev + 
        					item.commonName + item.shortName + item.aliasName

        // If Search is 3 or less, use only the bldgAlpha.  Otherwise search the blob.
        if (queryText.length > 3 ) {
        	return searchBlob.toLowerCase().indexOf(queryText.toLowerCase()) > -1
        } else {
        	return bldgAlpha.indexOf(queryText.toLowerCase()) > -1 
        }
    },

	clickHandler: function () {
		this.updateMainSidebar(true)
		this.updateContentSidebar(false)
		this.updateSearchResultSidebar(false)
	},

  }
}

</script>

<style>
.topToolBar {
	z-index: 100 !important;
}


/*.topTitle {
	font-family: 'Open Sans', sans-serif;
	font-size: 25px;
}*/

.topTitle {
	font-family: system-ui;
	font-weight: 400;
	font-size: 28px;
}

.blocka {
  height: 45px;
  margin-right: 20px;
  margin-left: 20px;
  float: left;
}

.v-menu__content {
	z-index: 1000 !important;
}


</style>



// WEBPACK FOOTER //
// src/components/TopBanner.vue